import { render, staticRenderFns } from "./MonitoringV3.vue?vue&type=template&id=f8dddc5a"
import script from "./MonitoringV3.vue?vue&type=script&lang=js"
export * from "./MonitoringV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports